import { Component, OnInit } from '@angular/core';
import { Http, Headers, RequestOptions, Response } from '@angular/http';
import { Router, ActivatedRoute } from '@angular/router';
import { AppSettings } from '../appSettings';
import { LoginService } from '../services/login.service';
import { CommonService } from '../services/common.service';
declare let swal: any;
declare var jquery:any;
declare var $ :any;

@Component({
  selector: 'app-buyinternetlife',
  templateUrl: './buyinternetlife.component.html',
  styleUrls: ['./buyinternetlife.component.css'],
})
export class BuyInternetLifeComponent implements OnInit {

  model: any = {};
  data:any={};
  entered:any;
  users :any= []; //storing the data from the API
  userRestApiUrl: string = AppSettings.Userlogin; //API common URL
  showLoginForm: boolean = false;
  selectedOption: string = '';
  name: string = '';
  website_price:any=30;
  constructor(
    private loginService: LoginService,
    private CommonService: CommonService,
    private router: Router,
    private route: ActivatedRoute,
    private http: Http
  ) {
    document.body.className = "login-page2";
  }

  ngOnInit() {
    this.entered = 0;
    this.route.params.subscribe(params => {
      this.name = params['name'];
      //call api get_sell_price_by_website model.website=this.name
      this.model.website=this.name;
      this.CommonService.insertdata(AppSettings.get_sell_price_by_website,this.model).subscribe((res) => {
        if(res.status==1){
          this.website_price=res.sell_price;
        }else{
          this.website_price=30;
          swal('Oops...', res.message, 'error');
        }
      });
    });
  }

  selectOption(option: string) {
    this.selectedOption = option;
    this.showLoginForm = true;
  }

  confirm() {
    if (this.selectedOption === 'activate') {
      // Handle Buy and Activate
    //   this.checklogin();
        swal('Oops...', 'Ask any Internet Life Advisor Worldwide For Activate', 'error');
    } else {
      // Handle Buy and Sale
      // For now, we'll just show a message
      swal('Oops', 'Ask any Internet Life Advisor Worldwide For Buy and Sale', 'error');
    
    }
  }

  cancel() {
    this.showLoginForm = false;
    this.selectedOption = '';
    this.model = {};
  }

  goToSignup() {
    this.router.navigate(['/signup']);
  }

  checklogin(){
    //alert(JSON.stringify(this.model));

    let usernme = null;
    let userpass = null;
    usernme = this.model.user_name;
    userpass = this.model.user_password;
   // alert(usernme);
    if((usernme==undefined || usernme==null)&&(userpass==undefined || userpass==null))
    {
      swal('Oops...', 'Enter Valid username or password', 'error');
      
      if(this.entered==0)
      {
        this.entered=1;
      }
      window.location.reload();
    }
    else 
    {
      if(usernme!=null && userpass!=null){
        //   this.CommonService.checkexistdata(this.userRestApiUrl,this.model).subscribe(data=>{
        //       if(data.exist==1)
        //       {
        //         let user_det = data.result[0];
        //         let chatcode = localStorage.getItem('chatcode');

        //         localStorage.setItem('currentUser', user_det.username);
        //         localStorage.setItem('currentUserID', user_det.id);
        //         localStorage.setItem('currentUsergroup',user_det.user_type);
        //         localStorage.setItem('usergroup',user_det.user_type);
        //         localStorage.setItem('user_fname',user_det.fname);
        //         localStorage.setItem('email',user_det.email);
        //         localStorage.setItem('address',user_det.address);
        //         localStorage.setItem('tamount',user_det.tamount);
        //         localStorage.setItem('pcktaken',user_det.pcktaken);
        //         localStorage.setItem('userRole',user_det.packInfo.website_type);
                
        //         swal('Success', 'Internet life purchased and activated!', 'success');

        //         if((user_det.user_type==1)&&(chatcode==null))
        //         {
        //           this.router.navigate(['./admindashboard']);
        //           // swal('', data.message, 'success');
        //         }
        //         else if(user_det.user_type==3)
        //         {
        //           this.router.navigate(['./admindashboard']);
        //         }
        //         else if(chatcode!=null)
        //         {
        //           //this.router.navigate(['chat/join', chatcode]);
        //           this.router.navigate(['/chat']);
        //            //return false;
        //         }
        //         else{
        //           this.router.navigate(['./dashboard']);
        //           // swal('', data.message, 'success');
        //         }
        //       }
        //       /*No Single Package is not yet activated*/
             
        //       else
        //       {
        //         swal('Oops...', data.message, 'error');
        //         this.router.navigate(['/']);
        //         window.location.reload();
        //       }
        //   });

         swal('Oops...', 'Ask any Internet Life Advisor Worldwide For Buy and Activate!', 'error');
        
      }
    }
 	
  }

  logout() {
        // remove user from local storage to log user out
      	// swal('', 'You have Successfully Logged Out', 'success');        
        localStorage.removeItem('currentUser');
        localStorage.clear();
  }
}